export const barcodePrintPDF = async (metaData) => {
    let pdfDoc = {
        content: [
            // {
            //     image: 'sampleImage.jpg',
			// 	height: 60,            
            // },

        ], 
        "pageSize": 'A8',
        pageOrientation: 'landscape',
        // footer: {
		// 	columns: [
		// 		{ text: 'Powered By ACUIFY', alignment: 'right', color: '#160091' }
		// 	],
		// 	margin: [10, 10]
		// },
        styles: {
            barcode: {
                fontSize: 22,
                // alignment: 'center',
                bold: true,
            },
        }
    }
    if(metaData.productName) {
        pdfDoc.content.push({text:" " + "N.W : " + metaData.grossWeight + '\n'  +" K : " + metaData.purity, style: "barcode"});
    }
    // if(metaData.grossWeight) {
    //     pdfDoc.content.push({text:"Net Weight : " + metaData.grossWeight});
    // }
    // if(metaData.purity) {
    //     pdfDoc.content.push({text:"Purity : " + metaData.purity});
    // }
    var svg = document.querySelector("#barcode");
    var svgData = new XMLSerializer().serializeToString(svg);

    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    var img = document.createElement("img");
    img.setAttribute("src", "data:image/svg+xml;base64," + btoa(svgData));

    img.onload = function () {
        ctx.drawImage(img, 0, 0);
        // let imgSource = canvas.toDataURL("image/png")
        // pdfDoc.content[0].image = imgSource;
        pdfMake.createPdf(pdfDoc).download('a8');
    };
}



// WEBPACK FOOTER //
// ./src/utils/barcodePrint.js